import {
  LogicalOperatorTypes,
  SupportedTypes,
} from "../Elements/FilterSelect/LogicalOperatorsOptions";

/**
 * Return a list of filters according the selected boolen option
 * @param {*} filter
 * @param {*} lo
 */
const setBoolean = (filter, lo) => {
  const filters = [];

  if (lo.value) {
    // it allows to add filter which value is true AND false (because we also
    // have undefiend values)
    if (lo.value.checkbox_true)
      filters.push({
        type: LogicalOperatorTypes.selector,
        dimension: filter.dimension,
        value: "true",
      });

    if (lo.value.checkbox_false)
      filters.push({
        type: LogicalOperatorTypes.selector,
        dimension: filter.dimension,
        value: "false",
      });
  }

  return filters;
};

const loMapFuncSet = {
  [SupportedTypes.Boolean]: setBoolean,
};

/**
 * Return the druid filter according the Primitive Type (not by the Logical Operator.. )
 * @param {*} filter
 * @param {*} logicalOpetaror
 */
const QueryFilterBooleans = (filterProps, logicalOperator) =>
  loMapFuncSet[logicalOperator.primitiveType](filterProps, logicalOperator);
export default QueryFilterBooleans;
